// While a product tab is showing, the header's "Sign up free" button opens that tab's own
// sign-up modal instead of navigating. Returns a function that removes the listener.
export const onHeaderSignup = (element, open) => {
  const handler = (event) => {
    if (!event.target.closest('.ge-nav__btn') || !element.closest('.ge-panel--active')) return

    event.preventDefault()
    open()
  }
  document.addEventListener('click', handler)
  return () => document.removeEventListener('click', handler)
}
